import {QUESTION_TYPES_BY_CATEGORY, URLS} from '../constants/appConstants';
import Grid from '@mui/material/Grid';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {useTheme} from '@mui/material';
import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';

function SelectQuestionType() {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleQuestionTypeClick = (questionKey) => {
    navigate(`${URLS.QUESTION_CREATE}?selectedPollType=${questionKey}`);
  }
  return <>
    <CommonAppbar isMainPage={true} pageHeader={`Select question type`}/>
    <Box sx={{ml: 1, mr: 1, mt: 1}}>
      <Grid container spacing={2}>
        {Object.entries(QUESTION_TYPES_BY_CATEGORY).map(([category, questionTypes]) => {
          return <>
            <Grid item xs={12}>
              <h4>{category}</h4>
            </Grid>
            {Object.entries(questionTypes).map(([questionKey, questionValue]) => {
              return <Grid item xs={6}>
                <div>
                  <Card variant="outlined" onClick={() => handleQuestionTypeClick(questionKey)}>
                    <CardContent sx={{textAlign: 'center', color: theme.palette.primary.main}}>
                      <div>{questionValue.icon}</div>
                      <Typography variant="body1" display="block" sx={{fontSize: 20}}>
                        {questionValue.label}
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              </Grid>
            })}
          </>
        })}
      </Grid>
    </Box>

  </>
}

export default SelectQuestionType;